import React from 'react';
import './style.css';

const ContentPlaceholder = () => {

  return (<div className="wrapper">
    <h1>Уважаемые пациенты!</h1>
    <h2>ЗАПИСЬ НА МЕДОСМОТР ЧЕРЕЗ САЙТ ВРЕМЕННО НЕ РАБОТАЕТ</h2>
    <p>Записаться на любой медосмотр в Городском Центре Медосмотра с пн. по пт. возможно
      по телефонам <span className="bigger">+7 (383) 328-01-03, +7 (383) 209-03-01</span></p>
    <p>Приносим свои извинения за возможные неудобства!</p>
    <hr/>
    <p>Запись на детские медосмотры перед школой и садиком только по телефону +7 (383) 319-62-10</p>
  </div>)
}

export default ContentPlaceholder



// WEBPACK FOOTER //
// frontend/src/modules/ContentPlaceholder/index.jsx